import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/About.css';

function About() {
  const { t } = useTranslation();

  return (
    <section id='about' className='about about-with-dots'>
      <div className='dots-background'></div>
      <div className='about-container'>
        <div className='section-header'>
          <h2 className='section-title'>{t('about_company_title')}</h2>
        </div>

        <div className='about-content'>
          <div className='about-text'>
            <p>
              {t('about_company_p1')}
              <br />
              <br />
              {t('about_company_p2')}
              <br />
              <br />
              {t('about_company_p3')}
              <br />
              <br />
              {t('about_company_p4')}
            </p>
          </div>
          <div className='about-image-container'>
            <img src='/about_pc.jpg' alt={t('about_image_alt')} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
